<template>
  <v-form ref="form" lazy-validation class="pl-12 pr-12">
    <v-layout row wrap>
      <v-flex md12>
        <div class="mb-12 title font-weight-regular">Detalhes da viatura</div>
      </v-flex>
      <v-flex md4>
        <div class="subtitle-1 font-weight-regular blue--text text--darken-4">VTR</div>
      </v-flex>
      <v-flex md8>
        <v-text-field
          outlined
          clearable
          placeholder="VTR"
          v-model="vtr"
          :rules="vtrRules"
          dense
          type="text"
          color="teal accent-3"
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        <div class="subtitle-1 font-weight-regular blue--text text--darken-4">Tipo do veículo</div>
      </v-flex>
      <v-flex md8>
        <v-select
          outlined
          clearable
          placeholder="Tipo"
          :items="tipos"
          v-model="type"
          :rules="baseRules"
          dense
          color="teal accent-3"/>
      </v-flex>
      <v-flex md4>
        <div class="subtitle-1 font-weight-regular blue--text text--darken-4">Placa</div>
      </v-flex>
      <v-flex md8>
        <v-text-field
          outlined
          clearable
          placeholder="Placa"
          v-model="placa"
          :rules="placaRules"
          dense
          type="text"
          color="teal accent-3"
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        <div class="subtitle-1 font-weight-regular blue--text text--darken-4">Base</div>
      </v-flex>
      <v-flex md8>
        <v-select
          outlined
          clearable
          placeholder="Base"
          :items="bases"
          item-text="name"
          item-value="id"
          v-model="base"
          :rules="baseRules"
          dense
          color="teal accent-3"/>
      </v-flex>
    </v-layout>
    <v-layout class="mt-2" row wrap></v-layout>
  </v-form>
</template>

<script>
export default {
    name:'AmbulanceInfo',
    props:['ambulance'],
    data:()=>({
        vtr: undefined,
        type: undefined,
        placa: undefined,
        base: undefined,
        vtrRules:[
            v=> !!v || 'VTR precisa ser preenchido!'
        ],
        typeRules:[
            v=> !!v || 'Tipo precisa ser preenchido!'
        ],
        baseRules:[
            v=> !!v || 'Base precisa ser preenchido!'
        ],
        placaRules:[
            v=> !!v || 'Placa precisa ser preenchido!'
        ],
        tipos: ['USA', 'VIR', 'USB', 'HEL', 'MOT', 'LAN', 'VTI']
    }),
    async created(){
      await this.$store.dispatch('downloadBases');
    },
    computed:{
        selectedAmbulanceInfo(){
            let selected = this.$store.getters.selectedAmbulance
            if(!selected){
                return {}
            }
            return selected  
        },
        bases(){
          return this.$store.getters.bases;
        }
    },
    methods:{
        setAmbulanceInfo(){
            if(this.$refs.form.validate()){
                return {
                    name : this.vtr,
                    type : this.type,
                    license : this.placa,
                    base_id : this.base
                }
            }
            return false
        }
    }
};
</script>

<style>
</style>